module.exports = __webpack_public_path__ + "img/flightworks-logo.07484dc8.jpg";